import { onModuleClick } from 'owa-workloads';
import { logUsage } from 'owa-analytics';
import { orchestrator } from 'satcheljs';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';

orchestrator(onModuleClick, actionMessage => {
    const { module, currentlySelectedModule, activeModuleAction } = actionMessage;
    const mailboxInfo = getModuleContextMailboxInfo();

    // If clicked workload is the selected module and there is an action given for it (ex: mail is to select default folder),
    // then call that action.
    if (module === currentlySelectedModule && activeModuleAction) {
        activeModuleAction();
    }

    logUsage(
        'ModuleSwitch',
        mailboxInfo,
        [currentlySelectedModule?.toString(), module.toString()],
        { isScorecardEvent: true }
    );

    logUsage(
        'LeftRailAppClick',
        mailboxInfo,
        [module.toString(), currentlySelectedModule?.toString(), false /* isLaunchPageApp */],
        { isScorecardEvent: true }
    );
});
